import React from 'react';
import './Header.scss';
import { NavLink } from 'react-router-dom'

class Header extends React.Component {
  render() {
    return <div className='mainMenuContainer'>
      <NavLink className='link about' activeClassName="active" to="/startsida">Startsida</NavLink>
      <NavLink className='link interest' activeClassName="active" to="/intresseanmalan">Intresseanmälan</NavLink>
      <NavLink className='link error' activeClassName="active" to="/felanmalan">Felanmälan</NavLink>
      <NavLink className='link contact' activeClassName="active" to="/kontakt">Kontakt</NavLink>
      </div>
  }
}

export default Header